import { ACTIONS } from '@~/actions/modal';

const initialState = null;

export default function defaultExport(state = initialState, { type, payload }) {
  switch (type) {
    case ACTIONS.MODAL_OPEN:
      return payload;
    case ACTIONS.MODAL_CLOSE:
      return null;
    default:
      return state;
  }
}
